import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const ProductIngredientFeedback = lazyWithPreload(
  () => import('./ProductIngredientFeedback'),
)
